import React from 'react';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import LoadingShimmer from '../LoadingShimmer/LoadingShimmer';

// Styles
import './KudoItemLoading.scss';

const KudoItemLoading = () => {
  const baseClassName = 'KudoItemLoading';

  return (
    <WpContainer className={baseClassName}>
      <WpContainerBody>
        <div className={`${baseClassName}__header`}>
          <LoadingShimmer shape="circle" width="40px" height="40px" />
          <div className={`${baseClassName}__header__details`}>
            <LoadingShimmer shape="rectangle" width="60%" height="16px" />
            <LoadingShimmer shape="rectangle" width="50%" height="14px" />
          </div>
        </div>
        <div className={`${baseClassName}__body`}>
          <LoadingShimmer shape="square" width="100%" height="176px" />
        </div>
        <div className={`${baseClassName}__message`}>
          <LoadingShimmer shape="rectangle" width="80%" height="16px" />
          <LoadingShimmer shape="rectangle" width="45%" height="16px" />
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default KudoItemLoading;
